// Initialize accordions
function initializeAccordions() {

  // Performance optimization: Use requestIdleCallback or setTimeout for non-critical animations
  const scheduleAnimation = (callback) => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback, { timeout: 1000 });
    } else {
      setTimeout(callback, 100);
    }
  };

  // Initialize accordions that should be open by default
  scheduleAnimation(() => {
    document.querySelectorAll('[data-accordion][data-accordion-open]').forEach(openAccordion => {
      const trigger = openAccordion.querySelector('[data-accordion-trigger]');
      const contentId = trigger.getAttribute('aria-controls');
      const content = document.getElementById(contentId);
      const icon = trigger.querySelector('.accordion-icon');
      
      if (content) {
        content.style.height = 'auto';
        trigger.setAttribute('aria-expanded', 'true');
      }
      if (icon) {
        icon.style.transform = 'rotate(45deg)';
      }
    });
  });
}

// Function to close all accordions except the one being opened
function closeAllAccordions(exceptIndex) {
  // Close all accordion contents
  document.querySelectorAll('[id^="accordion-content-"]').forEach(content => {
    const contentIndex = content.id.replace('accordion-content-', '');
    if (contentIndex !== exceptIndex) {
      content.style.height = '0';
    }
  });

  // Reset all accordion buttons and icons
  document.querySelectorAll('[onclick^="toggleAccordion"]').forEach(button => {
    const buttonIndex = button.getAttribute('onclick').match(/toggleAccordion\('([^']+)'\)/)?.[1];
    if (buttonIndex !== exceptIndex) {
      button.setAttribute('aria-expanded', 'false');
      const icon = button.querySelector('.accordion-icon');
      if (icon) {
        icon.style.transform = 'rotate(0deg)';
      }
    }
  });
}

function toggleAccordion(index) {
  const content = document.getElementById(`accordion-content-${index}`);
  const button = content.previousElementSibling;
  const isExpanded = button.getAttribute('aria-expanded') === 'true';
  
  // If we're opening this accordion, close all others first
  if (!isExpanded) {
    closeAllAccordions(index);
  }
  
  // Toggle icon rotation
  const icon = button.querySelector('.accordion-icon');
  if (icon) {
    icon.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(45deg)';
  }

  // Toggle content visibility
  if (isExpanded) {
    content.style.height = '0';
    button.setAttribute('aria-expanded', 'false');
  } else {
    content.style.height = 'auto';
    button.setAttribute('aria-expanded', 'true');
  }

  // Update ScrollTrigger after accordion content changes
  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.refresh();
  }
}

// Initialize accordions when DOM is ready with performance optimization
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    // Delay initialization to reduce initial CPU load
    setTimeout(initializeAccordions, 2000);
  });
} else {
  // Delay initialization to reduce initial CPU load
  setTimeout(initializeAccordions, 2000);
}